import { Component, inject, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { QnSbnService } from '../services/qn-sbn-service.service';
import { NotificationTableComponent } from './notification-table/notification-table.component';
import { NotificationSearchComponent } from './notification-search/notification-search.component';

import { AppUtils } from '../utlis/app-utils';
import { NotificationFilterComponent } from './notification-filter/notification-filter.component';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [OneWebComponentsAngularModule, NotificationTableComponent, NotificationSearchComponent, NotificationFilterComponent],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
  providers: [AppUtils],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NotificationComponent implements OnInit {
 
  qnsbnService = inject(QnSbnService);
  http = inject(HttpClient);
  isLoggedIn$: Observable<boolean>;
  isLoggedIn: boolean = false;
  loading: boolean = false;
  notificationsList: any;
  spinBool: boolean = false;

  searchValueSel: any;
  filterOptions = { types: [], statuses: [], country: [] };
  filterOptSel = { types: [], statuses: [], country: [] };

  constructor() {

  }

  ngOnInit(): void {
    // Initialize filter options to ensure they're not empty
    this.filterOptions = { types: [], statuses: [], country: [] };
    
    // Don't call API here - let the table component handle it
    // this.getNotificationDetails(['all'], ['all'], ['all']);

    this.getIsLoggedIn();
    // Note: isLoggedIn$ is not initialized, so this subscription won't trigger
    // The table component will make the API call in its ngOnInit
  }

  private getIsLoggedIn(): void {
    //  this.isLoggedIn$ = this.ngShellService.toObservable(watchIsLoggedIn);
  }

  // Actions to perform when the user is logged 
  private async performLoggedInActions(): Promise<void> {
    // Removed duplicate API call - table component handles initial load
  }

  // Actions to perform when the user is logged out
  private performLoggedOutActions(): void {
  }

  private getNotificationDetails(type: any, status: any, country: any): void {
    this.qnsbnService.getNotificationOverviewData(['all'], ['all'], ['all']).subscribe(
      (data: any) => {
        this.notificationsList = data?.notificationOverview;
        this.filterOptions = this.extractFilters(data?.notificationOverview);
       
        this.loading = true;
        this.spinBool = false;
      }
    );
  }

  extractFilters(data: any[]): { types: string[], statuses: string[], country: string[] } {
    // Handle case where data might be undefined or empty
    if (!data || !Array.isArray(data) || data.length === 0) {
     
      return { types: [], statuses: [], country: [] };
    }

    return {
      types: this.extractTypes(data),
      statuses: this.extractStatuses(data),
      country: this.extractCountry(data)
    }
  }

  private extractTypes(data: any[]): string[] {
    if (!data || data.length === 0) return [];
    
    const types = data.map(item => item?.Type).filter(type => type);
    return Array.from(new Set(types));
  }

  private extractStatuses(data: any[]): string[] {
    if (!data || data.length === 0) return ['Completed'];
    
    const statuses = data.map(item => (item?.CustomerStatus || item?.Status)).filter(status => status);
    return [...Array.from(new Set(statuses)), 'Completed'];
  }

  private extractCountry(data: any[]): string[] {
    if (!data || data.length === 0) return [];
    
    const country = data.map(item => item?.Country).filter(country => country);
    return Array.from(new Set(country));
  }


  searchValueInp(data: any) {
    this.searchValueSel = data;
  }

  filterOptInp(data: any): void {
    this.filterOptSel = data;
  }

  updateFilterOptions(options: { types: string[], statuses: string[], country: string[] }): void {
    this.filterOptions = options;
  }

}
